import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Loading, LoadingController, LoadingOptions, Platform } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

/*
  Generated class for the LoaderProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LoaderProvider {
  pool: LoaderPrivate[] = [];
  active: Loading;
  id: number = 0;
  timerId?: any = null;

  constructor(public http: HttpClient, public loadingCtrl: LoadingController) { }

  dismissAll() {
    this.pool = [];
    if (this.active !== null) {
      this.active.dismiss().then(() => (this.active = null));
    }
  }

  create(opts?: LoadingOptions): LoadingPoupup {
    this.id++;
    this.addText(this.id, opts);
    return new LoadingPoupup(this, this.id);
  }

  addText(id: number, opts?: LoadingOptions) {
    if (!this.active) {
      this.active = this.loadingCtrl.create(opts);
      this.active.present().then(() => { });
    } else {
    }
    this.pool.push({ text: opts.content, id: id });
  }

  removeId(id: number, resolve: Function) {
    this.pool = this.pool.filter(x => x.id !== id);
    if (this.pool.length > 0 && this.active !== null) {
      this.active.setContent(this.pool[this.pool.length - 1].text);
      resolve();
    } else {
      if (this.timerId !== null) {
        clearTimeout(this.timerId);
        this.timerId = null;
      }
      if (this.active !== null) {
        this.timerId = setTimeout(() => {
          if (this.active)
            this.active.dismiss().then(() => {
              resolve();
            });
          this.active = null;
          this.timerId = null;
        }, 200);
      } else {
        resolve();
      }
    }
  }
  presentId(id: number, resolve: Function) {
    this.active.setContent(this.pool[this.pool.length - 1].text);
    resolve();
  }
}

interface LoaderPrivate {
  text: string;
  id: number;
}

export class LoadingPoupup {
  constructor(public prov: LoaderProvider, public id: number) { }

  dismiss(): Promise<Object> {
    return new Promise((resolve, reject) => {
      this.prov.removeId(this.id, resolve);
    });
  }

  present(): Promise<Object> {
    return new Promise((resolve, reject) => {
      this.prov.presentId(this.id, resolve);
    });
  }
}



// WEBPACK FOOTER //
// /src/providers/loader/loader.ts